<ng-template #sortingDialog let-dialogRef let-dialogData="data">
  <mb-dialog class="sorting-dialog" [fullScreenMobile]="true">
    <mb-dialog-header class="sorting-dialog__header" [showCloseBtn]="true" (closeDialog)="dialogRef.close()">
    </mb-dialog-header>
    <mb-dialog-body class="sorting-dialog__body">
      <h1 class="sorting-dialog__body__title">Ordenar por</h1>
      <mb-radio-group class="sorting-dialog__body__radio-group" [(value)]="sortingValue">
        <mb-radio class="sorting-dialog__body__radio-group--item" value="recommended" i18n="@@sorting__recommended">Más
          vendidos
        </mb-radio>
        <mb-radio class="sorting-dialog__body__radio-group--item" value="price-ASC" i18n="@@sorting__price-ASC">Precio
          más bajo
        </mb-radio>
        <mb-radio class="sorting-dialog__body__radio-group--item" value="price-DESC" i18n="@@sorting__price-DESC">Precio
          más alto
        </mb-radio>
        <mb-radio class="sorting-dialog__body__radio-group--item" value="stars-DESC" i18n="@@sorting__stars-DESC">Más
          estrellas
        </mb-radio>
        <mb-radio class="sorting-dialog__body__radio-group--item" value="stars-ASC" i18n="@@sorting__stars-ASC">Menos
          estrellas
        </mb-radio>
        <mb-radio class="sorting-dialog__body__radio-group--item" value="rating-DESC" i18n="@@sorting__rating-DESC">
          Mejor puntuación
        </mb-radio>
      </mb-radio-group>
    </mb-dialog-body>
    <mb-dialog-footer class="sorting-dialog__footer">
      <button mb-button variant="principal" color="primary" [disabled]='storedSortingValue === sortingValue'
        (click)='applyChange(dialogRef);'>
        Aplicar
      </button>
    </mb-dialog-footer>
  </mb-dialog>
</ng-template>

<button mb-button variant="floating" color="secondary"
  [loading]="loading" [disabled]='disabled' (click)="togglesOpenDialog()" id="sorting-button">

  <mb-icon icon="sorting"></mb-icon> 
  <span i18n="@@sorting__status">{{sortingValue !== 'recommended' ? 'Ordenado' : 'Ordenar'}}</span>
</button>